import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ModalComponent } from 'app/components/modal/modal.component';
import { ModalService } from 'app/services/modal.service';

export enum BasicModalResult {
    Dismiss,
    PrimaryAction,
    SecondaryAction
}

@Component({
    selector: 'psm-basic-modal',
    templateUrl: 'basicModal.component.html'
})
export class BasicModalComponent extends ModalComponent<BasicModalResult> implements OnInit {
    public resourcePath: string;
    public title: string;
    public subtitle: string;
    public content: string;
    public primaryAction: string;
    public secondaryAction: string;
    public icon: string;

    constructor(modalService: ModalService, router: Router, private translate: TranslateService) {
        super(modalService, router);
    }

    public async ngOnInit() {
        if (!this.resourcePath) { return; }

        let resource = await this.translate.get(this.resourcePath).toPromise();
        this.title = resource.title;
        this.subtitle = resource.subtitle;
        this.content = resource.content;
        this.primaryAction = resource.primaryAction;
        this.secondaryAction = resource.secondaryAction;
    }

    public onCloseClicked() {
        this.close(BasicModalResult.Dismiss);
    }

    public onPrimaryAction() {
        this.close(BasicModalResult.PrimaryAction);
    }

    public onSecondaryAction() {
        this.close(BasicModalResult.SecondaryAction);
    }

    protected onNavigation() {
        this.close(BasicModalResult.Dismiss);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modal/basicModal.component.ts